function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { Chart, ChartLoadingPlaceholder, ChartNoDataPlaceholder } from '../../../Chart';
import { chartOptions } from './chartOptions';
import { doSeries } from './utils';
import { FooterNotes } from './partials';
var FundScatterComparison = function (_React$Component) {
  _inherits(FundScatterComparison, _React$Component);
  var _super = _createSuper(FundScatterComparison);
  function FundScatterComparison() {
    var _this;
    _classCallCheck(this, FundScatterComparison);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      options: null,
      status: 'initial'
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function (target) {
      _this.props.onHover && _this.props.onHover(target.id);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      _this.props.onHover && _this.props.onHover(null);
    });
    _defineProperty(_assertThisInitialized(_this), "handleProductClick", function (url) {
      _this.props.history.push(url);
    });
    return _this;
  }
  _createClass(FundScatterComparison, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        funds = _this$props.funds,
        xAxis = _this$props.xAxis,
        yAxis = _this$props.yAxis,
        productType = _this$props.productType,
        fetching = _this$props.fetching,
        fetched = _this$props.fetched,
        axis = _this$props.axis,
        contextFunds = _this$props.contextFunds;
      var shortSingularLowercase = getProductTypeLabel(productType, 'shortSingular', 'lowercase');
      var actions = {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      };
      if (fetching) return React.createElement(ChartLoadingPlaceholder, null);
      if (fetched && !funds.length) return React.createElement(ChartNoDataPlaceholder, null);
      var options = chartOptions(this.props.theme, xAxis, yAxis, actions);
      var _doSeries = doSeries(funds, this.props.colors, this.props.sizes, contextFunds, this.props.theme, xAxis.value, yAxis.value, productType, this.handleProductClick),
        series = _doSeries.series,
        fundClassesWithValidData = _doSeries.fundClassesWithValidData;
      if (!fundClassesWithValidData.length && contextFunds.length === 1) {
        var fund = contextFunds[0];
        return React.createElement(ChartNoDataPlaceholder, {
          message: "El ".concat(shortSingularLowercase, " ").concat(fund.name, " no tiene datos de ").concat(yAxis.label, " disponibles")
        });
      }
      options.series = series;
      options.yAxis.title.text = "".concat(axis.yAxis.label, ": ").concat(yAxis.label);
      options.xAxis.title.text = "".concat(axis.xAxis.label, ": ").concat(xAxis.label);
      return React.createElement("div", {
        style: {
          paddingLeft: '20px'
        }
      }, React.createElement(Chart, {
        options: options
      }), contextFunds.length > 1 && contextFunds.length !== fundClassesWithValidData.length ? React.createElement(FooterNotes, {
        light: true
      }, "* Algunos ", shortSingularLowercase, " no se muestran porque no hay datos disponibles para la selecci\xF3n actual.") : null);
    }
  }]);
  return FundScatterComparison;
}(React.Component);
export default withTheme(withRouter(FundScatterComparison));